/** Unterdrückt globale Fehler-Toasts (HttpErrorInterceptor). */
export const BCM_HTTP_SUPPRESS_ERRORS = 'suppress-errors';

/** GET mit erwartbarem 403 (fehlende Rolle) — kein Toast (#7202). */
export const BCM_HTTP_OPTIONAL_READ = 'x-bcm-optional-read';
